export const whiteMuted = 'rgba(255, 255, 255, 0.7)';
export const white = '#FFF';
export const darkBlue = '#023B4D';
